import type { ContractFunctionName, Hex } from 'viem'

import type { Prettify } from '@repo/utils'

import type { VaultAbi } from '../abis.js'
import type { ReverseMapping } from './types.js'

/** Type for function names in the Vault ABI */
export type VaultFunctionName = ContractFunctionName<typeof VaultAbi>

/** Mapping from selector → name for functions that call `timelocked()` */
export const VAULT_V2_TIMELOCKED_SELECTORS = {
  '0xb2e32848': 'abdicate',
  '0x60d54d41': 'addAdapter',
  '0x5c1a1a4f': 'decreaseTimelock',
  '0xf6f98fd5': 'increaseAbsoluteCap',
  '0x2438525b': 'increaseRelativeCap',
  '0x47966291': 'increaseTimelock',
  '0x585cd34b': 'removeAdapter',
  '0x5b34b823': 'setAdapterRegistry',
  '0x3e9d2ac7': 'setForceDeallocatePenalty',
  '0xb192a84a': 'setIsAllocator',
  '0xfe56e232': 'setManagementFee',
  '0x9faae464': 'setManagementFeeRecipient',
  '0x70897b23': 'setPerformanceFee',
  '0x6a5f1aa2': 'setPerformanceFeeRecipient',
  '0x04dbf0ce': 'setReceiveAssetsGate',
  '0x2cb19f98': 'setReceiveSharesGate',
  '0x871c979c': 'setSendAssetsGate',
  '0xc21ad028': 'setSendSharesGate'
} as const satisfies Record<Hex, VaultFunctionName>

/** Type for functions that call `timelocked()` */
export type VaultTimelockType =
  (typeof VAULT_V2_TIMELOCKED_SELECTORS)[keyof typeof VAULT_V2_TIMELOCKED_SELECTORS]

/** Mapping from name → selector for functions that call `timelocked()` */
export const VAULT_V2_TIMELOCKED_NAME_TO_SELECTOR = Object.fromEntries(
  Object.entries(VAULT_V2_TIMELOCKED_SELECTORS).map(([hex, name]) => [name, hex])
) as Prettify<ReverseMapping<typeof VAULT_V2_TIMELOCKED_SELECTORS>>

/** Ordered array of all timelocked function names */
export const VAULT_V2_TIMELOCKED_FUNCTIONS = Object.values(
  VAULT_V2_TIMELOCKED_SELECTORS
) as readonly VaultTimelockType[]
